module.exports = __webpack_public_path__ + "static/media/4.3ff7d33c.jpg";